import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const awsCredsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAwsCreds: builder.query({
      query: () => '/aws_credentials',
      providesTags: (result = [], error, arg) => [
        {type: 'AwsCreds', id: 'LIST'},
      ]
    }),
    createAwsCred: builder.mutation({
      query: () => ({
        url: '/aws_credentials',
        method: 'POST'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: [{ type: 'AwsCreds', id: 'LIST' }],
    }),
    deleteAwsCred: builder.mutation({
      query: (id) => ({
        url: `/aws_credentials/${id}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: [{ type: 'AwsCreds', id: 'LIST' }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetAwsCredsQuery,
  useCreateAwsCredMutation,
  useDeleteAwsCredMutation
} = awsCredsApiSlice
